import { useEffect, useState, useContext } from "react";
import journalAccessGraphqlInstance from "@services/api/journalAccess.graphql";
import { UserContext } from "@contexts/User";

export const useJournalTypes = ({ enabled = true } = {}) => {
  const { profile } = useContext(UserContext);
  const [journalTypes, setJournalTypes] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState(null);

  useEffect(() => {
    let isCancelled = false;

    if (!enabled) {
      setJournalTypes([]);
      setIsLoading(false);
      setError(null);
      return () => {
        isCancelled = true;
      };
    }

    (async () => {
      setIsLoading(true);
      setError(null);

      try {
        const result = await journalAccessGraphqlInstance.getAllJournalTypes();
        if (!isCancelled) {
          setJournalTypes(result || []);
        }
      } catch (err) {
        if (!isCancelled) {
          setError(err?.message || "Failed to fetch journal types");
          setJournalTypes([]);
        }
      } finally {
        if (!isCancelled) {
          setIsLoading(false);
        }
      }
    })();

    return () => {
      isCancelled = true;
    };
  }, [enabled, profile]);

  return {
    journalTypes,
    isLoading,
    error,
  };
};

export const useAssignedJournalTypes = (userId, accountId) => {
  const [journalTypes, setJournalTypes] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState(null);

  useEffect(() => {
    let isCancelled = false;

    if (!userId || !accountId) {
      setJournalTypes([]);
      setIsLoading(false);
      setError(null);
      return () => {
        isCancelled = true;
      };
    }

    (async () => {
      setIsLoading(true);
      setError(null);
      setJournalTypes([]);

      try {
        const result = await journalAccessGraphqlInstance.getAllJournalTypes(
          userId,
          accountId,
        );
        if (!isCancelled) {
          setJournalTypes(result || []);
        }
      } catch (err) {
        if (!isCancelled) {
          setError(err?.message || "Failed to fetch assigned journal types");
          setJournalTypes([]);
        }
      } finally {
        if (!isCancelled) {
          setIsLoading(false);
        }
      }
    })();

    return () => {
      isCancelled = true;
    };
  }, [userId, accountId]);

  return {
    journalTypes,
    isLoading,
    error,
  };
};
